require('./bootstrap');
window.$ = window.jQuery = require('jquery');
require('./modulos/home/carrusel');
require('./modulos/home/mensajes');
require('slick-carousel');
import Player from './modulos/player';
import { CarruselPrincipal } from './modulos/home/carrusel-principal';

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

/* Video principal */
(function () {
    var $video = $("#video-principal");
    if ($video.length > 0) {
        var player = new Player($video, true);
        var videos = $(".banner-video:first").attr("data-videos").split(',');

        var apuntado = 0;
        var total = videos.length;

        if (total > 1) {
            $video.on("video-finalizado", function () {
                var proximo = apuntado + 1;
                if (proximo >= total) {
                    proximo = 0;
                }
                player.cargar(videos[proximo]);
                apuntado = proximo;
            })
        } else {
            $video.on("video-finalizado", function () {
                player.replay();
            })
        }
    }
})();

$('.banners-secundarios__a, .banners-secundarios__b').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    mobileFirst: true,
    respondTo: 'window',
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear'
});


function inicializacionHome() {
    /* Widget */
    var $videoWidget = $("#widget-video:not(.ini)");
    if ($videoWidget.length > 0) {
        $videoWidget.addClass("ini");
        var playerWidget = new Player($videoWidget, true);
        var $ctrProducto = $("#widget-producto");
        var total = $ctrProducto.find(".widget-producto").length;
        var apuntado = 0;
        $ctrProducto.find(".widget-producto").eq(apuntado).addClass("visible");

        if (total > 1) {
            $videoWidget.on("video-finalizado", function () {
                var proximo = apuntado + 1;
                if (proximo >= total) {
                    proximo = 0;
                }

                var $apuntado = $ctrProducto.find(".widget-producto").eq(apuntado);
                var $proximo = $ctrProducto.find(".widget-producto").eq(proximo);

                $apuntado.removeClass("visible");
                $proximo.addClass("visible");
                playerWidget.cargar($proximo.attr("data-codigo"));
                apuntado = proximo;
            })
        }
    }

    /* Banners del escaparate */
    $('.carrusel-banners.tipo-1:not(.ini)').addClass("ini").slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        prevArrow: '<div class="izq"><i class="fa fa-angle-left"></i></div>',
        nextArrow: '<div class="der"><i class="fa fa-angle-right"></i></div>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.carrusel-banners.tipo-2:not(.ini)').addClass("ini").slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: '<div class="izq"><i class="fa fa-angle-left"></i></div>',
        nextArrow: '<div class="der"><i class="fa fa-angle-right"></i></div>',
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    let totalBannersSecundarios = $('.carrusel-lista:not(.ini) .swiper-slide').length;

    if (totalBannersSecundarios > 0) {
        new Swiper('.carrusel-lista:not(.ini)', {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 2,
            centerInsufficientSlides: true,
            spaceBetween: 20,
            loop: totalBannersSecundarios >= 8,
            createElements: true,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".carrusel-lista__siguiente",
                prevEl: ".carrusel-lista__anterior",
            },
            pagination: {
                el: ".carrusel-lista__paginacion",
            },
        });

        $('.carrusel-lista:not(.ini)').addClass("ini");
    }
}

inicializacionHome();

new CarruselPrincipal();

/* Paginación */
var esperndoPagina = false;
var pagina = 1;
var $ctrEscaparate = $('#escaparate');
var paginas = $ctrEscaparate.attr("data-paginas");

$(window).on("scroll", function() {
    const urlParams = new URLSearchParams(window.location.search);
    if ($(document).height() - $(window).height() - 500 <= $(window).scrollTop() && esperndoPagina === false) {
        esperndoPagina = true;
        let paginaUrl = urlParams.get('pagina');
        if (paginaUrl) {
            pagina = paginaUrl;
        }
        let nuevaPagina = parseInt(pagina) + 1;
        if(nuevaPagina <= paginas) {
            var href = new URL(location.href);
            href.searchParams.set('pagina', ""+nuevaPagina);
            history.replaceState({}, '', href.toString());

            $.ajax({
                url: '/',
                type: "POST",
                data: {pagina: nuevaPagina},
                dataType: 'html',
                success: function(html) {
                    $ctrEscaparate.append(html);
                    inicializacionHome();
                    pagina = nuevaPagina;
                    esperndoPagina = false;
                },
                error: function (jqXHR) {
                    console.log('Error', jqXHR.responseText);
                },
                beforeSend: function() {
                    $("#cargador").show();
                },
                complete: function() {
                    $("#cargador").hide();
                }
            });
        }
    }
});

// Splash promocional

import { SplashPromo } from './modulos/splash-promo';
//
let splashPromo = new SplashPromo();

// Obtener el scroll inicial
let initialScroll = window.pageYOffset;

// Detectar el scroll
window.addEventListener('scroll', () => {

    // Obtener el scroll actual
    let currentScroll = window.pageYOffset;

    // Calcular la diferencia de píxeles scrollados
    let diff = (currentScroll - initialScroll) / window.innerHeight;

    if (diff > 2) {
        splashPromo.abrir();
    }

});